import {
    BackgroundCheckHistoryColumns,
    BackgroundCheckHistoryData,
    backgroundCheckHistoryEntityName,
} from '@/backend/features/background-check';
import { StorageContext } from '@juvare/platform-app/App';
import { StorageBackendApi } from '@juvare/platform-app/Storage';

export function getBackgroundCheckHistoryStorage(
    context: StorageContext,
): StorageBackendApi<BackgroundCheckHistoryData, BackgroundCheckHistoryColumns> {
    return context.storage<BackgroundCheckHistoryData, BackgroundCheckHistoryColumns>(backgroundCheckHistoryEntityName);
}
